import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { getAppConfig } from './app/app.config';

bootstrapApplication(AppComponent, getAppConfig()).catch((error: unknown) => {
  console.error(error);
});
